module.exports = __webpack_public_path__ + "static/media/logo.adb54fe0.svg";